import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-physician-document-view',
  templateUrl: './physician-document-view.component.html',
  styleUrls: ['./physician-document-view.component.css']
})
export class PhysicianDocumentViewComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {

    }


    ngOnInit() {
    }

}
